<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">管理</el-breadcrumb-item>
      <el-breadcrumb-item>活动列表管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="box-card">
      <el-row :gutter="20" v-if="canLook == 1">
        <el-button @click="addUserDialogVisible = true" type="primary"
          >添加</el-button
        >
      </el-row>
      <el-table :data="listData" border stripe>
        <el-table-column type="index"></el-table-column>
        <el-table-column
          label="id"
          prop="id"
          align="center"
          width="50px"
        ></el-table-column>
        <el-table-column label="封面" prop="fengmian" width="220px" align="center">
          <template slot-scope="scope">
            <el-image
              style="width: 160px; height: 80px"
              :src="scope.row.fengmian"
              fit="contain"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          label="标题"
          prop="title"
          align="center"
          width="150px"
        ></el-table-column>
        <el-table-column
          label="描述"
          prop="desc"
          align="center"
          width="150px"
        ></el-table-column>
        <el-table-column label="详情图片" prop="url" width="400px" align="center">
          <template slot-scope="scope">
            <div class="flex">
              <el-image
                style="width: 100px; height: 50px"
                :src="url"
                fit="contain"
                v-for="(url, index) in scope.row.content"
                :key="index"
              ></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="排序"
          prop="sort"
          align="center"
          width="80px"
        ></el-table-column>
        <el-table-column
          label="阅读量"
          prop="readCount"
          align="center"
          width="80px"
        ></el-table-column>

        <el-table-column
          label="创建时间"
          prop="create_at"
          align="center"
          width="110px"
        ></el-table-column>

        <el-table-column label="是否显示" width="80px" v-if="canLook == 1">
          <template slot-scope="scope">
            <el-switch
              @change="changeUserStated(scope.row)"
              v-model="scope.row.status"
            ></el-switch>
          </template>
        </el-table-column>

        <el-table-column label="操作" v-if="canLook == 1" width="180px">
          <template slot-scope="scope">
            <el-tooltip
              :enterable="false"
              content="编辑"
              effect="dark"
              placement="top"
            >
              <el-button
                @click="edit(scope.row.id)"
                icon="el-icon-edit"
                size="mini"
                type="primary"
              ></el-button>
            </el-tooltip>
            <!-- <el-tooltip
              :enterable="false"
              content="删除"
              effect="dark"
              placement="top"
            >
              <el-button
                @click="deleteItem(scope.row.id)"
                icon="el-icon-delete"
                size="mini"
                type="danger"
              ></el-button>
            </el-tooltip> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 添加对话框 -->
    <el-dialog
      :visible.sync="addUserDialogVisible"
      @close="addFormClose"
      title="添加"
      width="60%"
    >
      <el-form
        :model="addForm"
        :rules="addFormRules"
        label-width="80px"
        ref="addFormRef"
      >
        <el-form-item label="标题" prop="title">
          <el-input v-model="addForm.title"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="desc">
          <el-input v-model="addForm.desc"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="addForm.sort"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch
            @change="addChangeStated()"
            v-model="addForm.status"
          ></el-switch>
        </el-form-item>
        <el-form-item label="封面图片" prop="pic">
          <div v-if="addForm.fengmian">
            <el-image
              style="width: 300px; height: 150px"
              :src="addForm.fengmian"
              fit="contain"
            ></el-image>
            <i
              class="el-icon-circle-close"
              @click="clickAddFengmianDelete()"
            ></i>
          </div>
          <el-upload
            class="upload-demo"
            action="https://yxxapi.jxpyq666.com/common/uploads/activityInformationKnowledgeUploadImages"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :file-list="fileList"
            :on-success="addFengmianFileUploadSuccess"
            list-type="picture"
            :show-file-list="false"
            name="images"
            :limit="1"
          >
            <el-button size="small" type="primary">上传封面图片【1:1】</el-button>
             
          </el-upload>
        </el-form-item>

        <el-form-item label="详情图片" prop="pic">
          <div v-for="(url, index) in addForm.content" :key="index">
            <el-image
              style="width: 300px; height: 150px"
              :src="url"
              fit="contain"
            ></el-image>
            <i class="el-icon-circle-close" @click="clickAddDelete(index)"></i>
          </div>

          <el-upload
            class="upload-demo"
            action="https://yxxapi.jxpyq666.com/common/activityInformationKnowledgeUploadImages"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :file-list="fileList"
            :on-success="addFileUploadSuccess"
            list-type="picture"
            :show-file-list="false"
            name="images"
            :limit="20"
          >
            <el-button size="small" type="primary">点击上传详情的图片</el-button>
            <div slot="tip" class="el-upload__tip">
              请上传jpg/png文件，且不超过1m，一次上传一张图片
            </div>
          </el-upload>
        </el-form-item>
      </el-form>

      <span class="dialog-footer" slot="footer">
        <el-button @click="addUserDialogVisible = false">取 消</el-button>
        <el-button @click="addUser" type="primary">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑对话框 -->
    <el-dialog
      :visible.sync="editDialogVisible"
      @close="editFormClose"
      title="编辑"
      width="60%"
    >
      <el-form
        :model="editForm"
        :rules="editFormRules"
        label-width="80px"
        ref="editFormRef"
      >
        <el-form-item label="标题" prop="title">
          <el-input v-model="editForm.title"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="desc">
          <el-input v-model="editForm.desc"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="editForm.sort"></el-input>
        </el-form-item>
        <el-form-item label="阅读量" prop="readCount">
          <el-input v-model="editForm.readCount"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch
            @change="editChangeStated()"
            v-model="editForm.status"
          ></el-switch>
        </el-form-item>
        <el-form-item label="封面图片" prop="pic">
          <div v-if="editForm.fengmian">
            <el-image
              style="width: 300px; height: 150px"
              :src="editForm.fengmian"
              fit="contain"
            ></el-image>
            <i
              class="el-icon-circle-close"
              @click="clickEditFengmianDelete()"
            ></i>
          </div>
          <el-upload
            class="upload-demo"
            action="https://yxxapi.jxpyq666.com/common/uploads/activityInformationKnowledgeUploadImages"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :file-list="fileList"
            :on-success="editFileUploadSuccess"
            list-type="picture"
            :show-file-list="false"
            name="images"
            :limit="1"
          >
            <el-button size="small" type="primary">上传封面图片【1:1】</el-button> 
          </el-upload>
        </el-form-item>

        <el-form-item label="详情图片" prop="pic">
          <div v-for="(url, index) in editForm.content" :key="index">
            <el-image
              style="width: 300px; height: 150px"
              :src="url"
              fit="contain"
            ></el-image>
            <i class="el-icon-circle-close" @click="clickEditDelete(index)"></i>
          </div>
          <el-upload
            class="upload-demo"
            action="https://yxxapi.jxpyq666.com/common/uploads"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :file-list="fileList"
            :show-file-list="false"
            :on-success="filechangeUploadSuccess"
            list-type="picture"
            name="images"
            :limit="20"
          >
            <el-button size="small" type="primary">点击上传图片</el-button>
            <div slot="tip" class="el-upload__tip">
              请上传jpg/png文件，且不超过1m，一次上传一张图片
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span class="dialog-footer" slot="footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button @click="sureToedit()" type="primary">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isshow: true, //是否显示
      canLook: 1,
      queryInfo: {
        query: "",
        pagenum: 1,
        pagesize: 10,
      },
      total: 0,
      listData: [],
      // 添加用户的对话框是否显示
      addUserDialogVisible: false,
      // 添加用户数据
      addForm: {
        url: "",
        title: "",
        sort: "",
        fengmian: "",

        desc: "",
        status: false,
        content: [],
      },

      // 添加的表单校验
      addFormRules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        desc: [{ required: true, message: "请输入描述", trigger: "blur" }],
        content: [{ required: true, message: "请选择图片", trigger: "blur" }],
      },

      editForm: {
        id: "",
        title: "",
        sort: "",
        readCount: "",
        desc: "",
        fengmian: "",
        status: "",
        content: [],
      },

      // 编辑用户弹框显示
      editDialogVisible: false,
      // 编辑用户的表单校验
      editFormRules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        desc: [{ required: true, message: "请输入描述", trigger: "blur" }],
        content: [{ required: true, message: "请选择图片", trigger: "blur" }],
      },

      // 上传的图片
      fileList: [],
    };
  },
  created() {
    this.getLunBoData();
  },

  methods: {
    clickEditFengmianDelete() {
      this.editForm.fengmian = null;
    },
    clickAddFengmianDelete() {
      this.addForm.fengmian = null;
    },
    clickEditDelete(index) {
      this.editForm.content.splice(index, 1);
      console.log(index);
    },

    clickAddDelete(index) {
      this.addForm.content.splice(index, 1);
      console.log(index);
    },

    editChangeStated(e) {
      console.log(e);
    },

    async getLunBoData() {
      if (window.sessionStorage.getItem("pathCanLook") == 2) {
        //仅查看
        this.canLook = 2;
      }
      const { data: res } = await this.$http.get("/admin/activity/getList", {
        params: this.queryInfo,
      });
      console.log(res.result);
      if (res.code != 200) return this.$message.error("获取数据失败");
      this.listData = res.result.list;
      this.total = res.result.count;
    },

    // 更新用户的状态
    async changeUserStated(info) {
      const { data: res } = await this.$http.post(
        "/admin/activity/updateStatus",
        info
      );
      if (res.code != 200) {
        return this.$message.error("操作失败");
      }
      this.$message.success("操作成功");
      this.getLunBoData();
    },

    // 表单关闭事件
    addFormClose() {
      console.log(this.$refs);
      this.$refs.addFormRef.resetFields();
      this.fileList = [];
      this.isshow = true;
    },

    // 添加
    addUser() {
      this.$refs.addFormRef.validate(async (field) => {
        if (!field) return;
        const { data: res } = await this.$http.post(
          "/admin/activity/addInfo",
          this.addForm
        );
        if (res.code != 200) {
          return this.$message.error("添加失败");
        }
        this.$message.success("添加成功");
        this.addUserDialogVisible = false;
        this.getLunBoData();

        this.fileList = [];
        this.isshow = true;
        this.addForm.fengmian = null
        this.$refs.addFormRef.resetFields();
      });
    },

    // 编辑按钮点击
    async edit(userId) {
      const { data: res } = await this.$http.get("/admin/activity/detail", {
        params: {
          id: userId,
        },
      });
      console.log(res);
      if (res.code != 200) {
        return this.$message.error("获取信息失败");
      }
      this.editForm = res.result;
      this.editDialogVisible = true;
    },

    editFormClose() {
      this.editDialogVisible = false;
    },

    // 编辑确认
    sureToedit() {
      this.$refs.editFormRef.validate(async (field) => {
        if (!field) return;
        const { data: res } = await this.$http.post(
          "/admin/activity/editInfo",
          this.editForm
        );
        if (res.code != 200) {
          return this.$message.error("编辑失败");
        }
        this.$message.success("编辑成功");
        this.editDialogVisible = false;
        this.editForm.fengmian = null
        this.getLunBoData();
      });
    },

    //  删除
    async deleteItem(id) {
      console.log(id);
      const result = await this.$confirm(
        "将永久删除该数据, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      console.log(result);
      if (result == "confirm") {
        const { data: res } = await this.$http.post(
          "/admin/activity/delete",
          {
            id: id,
          }
        );
        if (res.code != 200) {
          return this.$message.error("删除失败");
        }
        this.$message.success("删除成功");
        this.getLunBoData();
      } else {
        return this.$message.info("删除已取消");
      }
    },

    //图片上传
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },

    handlePreview(file) {
      console.log(file);
    },
    addFengmianFileUploadSuccess(response, file, fileList){
      this.addForm.fengmian = response.result.show;
    },

    addFileUploadSuccess(response, file, fileList) { 
      this.addForm.content.push(response.result.show);
    },

    editFileUploadSuccess(response, file, fileList){
      this.editForm.fengmian = response.result.show;
    },

    filechangeUploadSuccess(response, file, fileList) { 
      this.editForm.content.push(response.result.show);
    },

    handleExceed(files, fileList) {
      console.log(files);
      console.log(fileList);
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },

    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },

    //是否显示
    isshowchange(res) {
      this.isshow = res;
      this.addForm.type = this.isshow == true ? 1 : 0;
    },

    //列表的显示设置
    async listSwitchchange(info) {
      console.log(info);
      const { data: res } = await this.$http.post("updatelunboShow", {
        id: info.id,
        type: info.type,
      });
      if (res.code != 200) {
        return this.$message.error("更新状态失败");
      }
      return this.$message.success("更新状态成功");
    },

    // 监听 pagesize 改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.pagesize = newSize;
      this.getList();
    },

    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      console.log(newPage);
      this.queryInfo.pagenum = newPage;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.flex {
  display: flex;
}
</style>
